import React from "react";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Checkbox,
	Chip,
	Grid,
	Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FactCheckIcon from "@mui/icons-material/FactCheck";

const ParteField = ({ label, value, fullWidth = false }) => (
	<Box sx={{ minWidth: 0, gridColumn: fullWidth ? { xs: "1 / -1", lg: "auto" } : "auto" }}>
		<Typography
			variant="caption"
			color="text.secondary"
			sx={{ display: "block", mb: 0.35, letterSpacing: 0.2 }}
		>
			{label}
		</Typography>
		<Typography
			variant="body2"
			sx={{
				fontWeight: 500,
				lineHeight: 1.35,
				wordBreak: "break-word",
			}}
		>
			{value}
		</Typography>
	</Box>
);

export const OperativosCaboAccordion = ({
	group,
	expanded,
	disabled,
	selectedPartes,
	onToggleExpanded,
	onToggleCaboSelection,
	onToggleParteSelection,
}) => {
	const totalPartesGrupo = group.partes.length;
	const selectedPartesGrupo = group.partes.filter((parte) =>
		Boolean(selectedPartes?.[parte.id_cuadrilla])
	).length;
	const allGroupSelected = totalPartesGrupo > 0 && selectedPartesGrupo === totalPartesGrupo;
	const someGroupSelected =
		selectedPartesGrupo > 0 && selectedPartesGrupo < totalPartesGrupo;

	return (
		<Accordion
			expanded={expanded}
			onChange={(_, isExpanded) => onToggleExpanded(group.id, isExpanded)}
			disableGutters
			sx={{
				border: "1px solid",
				borderColor: "divider",
				borderRadius: 2,
				overflow: "hidden",
				"&:before": { display: "none" },
			}}
		>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<Grid container alignItems="center" spacing={1.5} wrap="wrap">
					<Grid item>
						<Checkbox
							checked={allGroupSelected}
							disabled={disabled}
							indeterminate={someGroupSelected}
							onClick={(event) => event.stopPropagation()}
							onFocus={(event) => event.stopPropagation()}
							onChange={(event) => onToggleCaboSelection(group, event.target.checked)}
							size="small"
						/>
					</Grid>
					<Grid item size={{ xs: 12, md: 5, lg: 4 }}>
						<Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
							{group.nombre}
						</Typography>
						{group.nif_cabo && (
							<Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
								{group.nif_cabo}
							</Typography>
						)}
					</Grid>
					<Grid item size={{ xs: 12, md: "auto" }}>
						<Box
							sx={{
								display: "flex",
								gap: 1,
								flexWrap: "wrap",
								justifyContent: { xs: "flex-start", md: "flex-end" },
							}}
						>
							<Chip size="small" label={`${totalPartesGrupo} parte(s)`} />
							<Chip
								size="small"
								color={selectedPartesGrupo > 0 ? "primary" : "default"}
								label={`${selectedPartesGrupo} seleccionados`}
							/>
						</Box>
					</Grid>
				</Grid>
			</AccordionSummary>
			<AccordionDetails sx={{ px: 0, py: 0 }}>
				<Grid container direction="column" size={{ xs: 12 }}>
					{group.partes.map((parte) => (
						<Box
							key={parte.id_cuadrilla}
							sx={{
								display: "grid",
								gridTemplateColumns: {
									xs: "32px minmax(0, 1fr)",
									md: "32px repeat(2, minmax(0, 1fr))",
									lg: "32px 90px minmax(260px, 1.7fr) 120px minmax(220px, 1.2fr) 140px 160px 90px 110px",
								},
								columnGap: 2,
								rowGap: 1.25,
								alignItems: "start",
								px: 2,
								py: 1.75,
								borderTop: "1px solid",
								borderColor: "divider",
							}}
						>
							<Checkbox
								checked={Boolean(selectedPartes?.[parte.id_cuadrilla])}
								disabled={disabled}
								onChange={() => onToggleParteSelection(parte.id_cuadrilla)}
								size="small"
								sx={{ mt: 0.4 }}
							/>
							<ParteField label="ID" value={parte.id_cuadrilla} />
							<ParteField label="Grupo" value={parte.nombre_cuadrilla || "-"} fullWidth />
							<ParteField label="Fecha" value={parte.fecha_cuadrilla || "-"} />
							<ParteField label="Empresa" value={parte.nombre_cliente || "-"} />
							<ParteField
								label="Delegacion"
								value={parte.nombre_delegacion || "Sin delegacion"}
							/>
							<ParteField label="Campaña" value={parte.nombre_campana || "Sin campaña"} />
							<ParteField label="Personas" value={parte.total_recolectores || 0} />
							<Box sx={{ display: "flex", justifyContent: { xs: "flex-start", lg: "center" } }}>
								<ParteField label="Operativo" value={<Chip
									size="small"
									icon={<FactCheckIcon />}
									color={Number(parte.operativo || 0) === 1 ? "success" : "default"}
									label={Number(parte.operativo || 0) === 1 ? "Si" : "No"}
								/>} />
							
							</Box>
						</Box>
					))}
				</Grid>
			</AccordionDetails>
		</Accordion>
	);
};
